import Gauge from '@/components/Gauge';
import { toPercentage } from '@/utilities/formatting';

interface Props {
  companyName: string;
  ROCE1y: number;
  ROCE3y: number;
  labels?: {
    title: string;
    titleROCE1y: string;
    titleROCE3y: string;
    keyROCE1y: string;
    keyROCE3y: string;
    notAvailable: string;
  };
}

export const ROCEGauge = ({
  ROCE1y,
  ROCE3y,
  companyName,
  labels = {
    title: 'ROCE',
    titleROCE1y: `${companyName} Last Year`,
    titleROCE3y: `${companyName} 3 Years Ago`,
    keyROCE1y: 'last year',
    keyROCE3y: '3 years ago',
    notAvailable: 'n/a',
  },
}: Props) => {
  return (
    <Gauge
      title={labels.title}
      keys={['last year', '3 years ago']}
      keyLabels={{
        'last year': labels.keyROCE1y,
        '3 years ago': labels.keyROCE3y,
      }}
      entityTitles={{
        'last year': labels.titleROCE1y,
        '3 years ago': labels.titleROCE3y,
      }}
      entities={{
        'last year': ROCE1y,
        '3 years ago': ROCE3y,
      }}
      formatter={(value: number | null) =>
        value !== null ? toPercentage(value, 1) : labels.notAvailable
      }
      numTicks={4}
      from={0}
      to={0.3}
    />
  );
};
